import { isStandalone } from 'utils/environment';

// This header is added to responses in the ingress layer so it needs to be resolved in FE
export default (async () => {
  if (isStandalone()) return;
  try {
    const providerRes = await fetch('/provider');
    const provider = providerRes?.headers.get('x-clubspark-root-provider-id');
    (window as any).__provider__ = provider;

    /*
       TODO: This is not being used currently since client config is loaded from .config files.
       This is being removed temporarily because the config.mjs setup script is erroneously being
       bundled into the vite dev server build and being served at the /config route, causing runtime
       errors. We need a vite proxy to redirect /config to the Strapi API, as per the nginx.conf
       We will re-enable this flow as part of COMP-15985 to support dynamic client config loading.
    */
    // const configRes = await fetch(
    //   `/config?filters[organisationId]=${provider}&populate[siteConfig][on][site-config.tournament-desk][populate]=*`,
    // );
    // const json = await configRes.json();
    // const config = json?.data?.[0]?.attributes?.siteConfig?.[0];
    // (window as any).__client_config__ = config;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error((e as any)?.message);
  }
})();

export const getRootProviderId = () => (window as any).__provider__;
